import {CookiePolicyOpenESB} from "@next/eventservice"

const openedESB = new CookiePolicyOpenESB()

export const PublishCookiePolicyOpen = () => {
    openedESB.publish()
}

export const SubscribeCookiePolicyOpen = (cb: () => void) => {
    return openedESB.subscribe(cb)
}
